/**
 * Enum for a type of comparison operator. For each type the emitted filter from
 * the RangeFilterPicker component has a slightly different structure.
 */
export enum ComparisonType {
  GREATER_THAN = 0, // One comparison used - "field > [amount]".
  LESS_THAN = 1, // One comparison used - "field < [amount]".
  EQUAL_TO = 2, // Two comparisons used - "field >= [amount] AND field <= [amount]".
}
